import type { DataGridProps } from '@mui/x-data-grid'
import type { PaginationProps } from 'shared/hooks/use-pagination'

type DataGridPaginationProps = Required<
  Pick<
    DataGridProps,
    | 'page'
    | 'pageSize'
    | 'rowsPerPageOptions'
    | 'onPageChange'
    | 'onPageSizeChange'
  >
>

// DataGrid pages are zero-based and change one step at a time, while
// usePagination pages are one-based and navigated with cursors.
export const mapPaginationToDataGridProps = (
  pagination: PaginationProps
): DataGridPaginationProps => {
  const currentPage = pagination.page - 1

  const onPageChange = (newPage: number) => {
    if (newPage === currentPage) return
    if (newPage === 0) {
      pagination.goFirstPage()
    } else if (newPage > currentPage) {
      pagination.goNextPage()
    } else {
      pagination.goPrevPage()
    }
  }

  return {
    page: currentPage,
    pageSize: pagination.onPage,
    rowsPerPageOptions: pagination.pageSizeOptions,
    onPageChange,
    onPageSizeChange: pagination.changePageSize,
  }
}
